(function (window, document) {
  'use strict';

  var STORAGE_KEY = 'ag_attribution_v1';
  var ACTIVE_TOUCH_KEY = STORAGE_KEY + '_active_touch';
  var MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000;
  var VISIT_IDLE_MS = 30 * 60 * 1000;
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  var CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'epik'];
  // The candidate builder disables Google memory and booking events for the Meta-only release.
  var GOOGLE_CLICK_MEMORY_ENABLED = true;
  var CAPTURE_KEYS = UTM_KEYS.concat(CLICK_KEYS, GOOGLE_CLICK_MEMORY_ENABLED ? ['gad_source', 'gad_campaignid'] : []);
  var PLATFORM_KEY = STORAGE_KEY + '_clicks';
  var capturedUrl = '';

  // A tab-local, idle-limited marker proves which stored touch belongs to this
  // visit. Old storage alone is not permission to attach a newly arrived cookie.
  function activeTouch(current, now, newTouch, original) {
    try {
      var active = newTouch ? { original: original } :
        JSON.parse(window.sessionStorage.getItem(ACTIVE_TOUCH_KEY) || 'null');
      var key = JSON.stringify([current.capturedAt, current.attribution_captured_at, current.latest_landing_url]);
      if (!newTouch && (!active || active.key !== key || !Number.isFinite(active.seenAt) ||
        active.seenAt > now || now - active.seenAt > VISIT_IDLE_MS)) return null;
      active.key = key;
      active.seenAt = now;
      window.sessionStorage.setItem(ACTIVE_TOUCH_KEY, JSON.stringify(active));
      return active;
    } catch (_error) { return null; }
  }

  function fillMetaIdentity(prefix, current, capturedAtMs) {
    // Unlike fbp, fbc describes a click. Never borrow another touch's cookie.
    var fbclid = captureValue('fbclid', current[prefix + 'fbclid']);
    if (!current[prefix + 'fbc'] && fbclid && Number.isFinite(capturedAtMs) &&
      capturedAtMs <= Date.now() && Date.now() - capturedAtMs <= MAX_AGE_MS) {
      current[prefix + 'fbc'] = 'fb.1.' + capturedAtMs + '.' + fbclid;
    }
  }

  // Shopify applies the merchant's regional policy as well as visitor choices.
  // An unavailable API is not permission. Never infer consent from a cookie.
  function storageAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(privacy && privacy.marketingAllowed() === true &&
        privacy.analyticsProcessingAllowed() === true);
    } catch (_error) { return false; }
  }

  function advertisingAllowed() {
    try {
      return storageAllowed() && window.Shopify.customerPrivacy.saleOfDataAllowed() === true;
    } catch (_error) { return false; }
  }

  function clean(value, maxLength) {
    if (value === null || value === undefined) return '';
    var normalized = String(value).trim();
    if (!normalized || /[\r\n]/.test(normalized)) return '';
    return normalized.slice(0, maxLength || 512);
  }

  function captureValue(key, value) {
    if (key === 'epik') return pinterestClick(value);
    if (key === 'fbclid') {
      var click = String(value || '').trim();
      return /^[A-Za-z0-9_-]{1,512}$/.test(click) ? click : '';
    }
    return clean(value);
  }

  function safeUrl(raw, includeAttribution) {
    if (!clean(raw, 2048)) return '';
    try {
      var parsed = new URL(raw, window.location.origin);
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return '';
      var result = parsed.origin + parsed.pathname;
      if (!includeAttribution) return result.slice(0, 2048);
      var allowed = new URLSearchParams();
      CAPTURE_KEYS.forEach(function (key) {
        var value = captureValue(key, parsed.searchParams.get(key));
        if (value) allowed.set(key, value);
      });
      var query = allowed.toString();
      return (result + (query ? '?' + query : '')).slice(0, 2048);
    } catch (_error) {
      return '';
    }
  }

  function readStored() {
    if (!storageAllowed()) return null;
    try {
      var value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      var captured = value && Date.parse(value.capturedAt);
      var latest = value && Date.parse(value.attribution_captured_at);
      var now = Date.now();
      function fresh(at) { return Number.isFinite(at) && at <= now && now - at <= MAX_AGE_MS; }
      if (!fresh(captured)) {
        if (!fresh(latest)) {
          window.localStorage.removeItem(STORAGE_KEY);
          return null;
        }
        // The first touch can expire before a later visit. Promote the complete
        // latest touch, clearing old-only fields rather than mixing campaigns.
        Object.keys(value).forEach(function (key) {
          if (key.indexOf('original_') === 0) delete value[key];
        });
        Object.keys(value).forEach(function (key) {
          if (key.indexOf('latest_') === 0) value['original_' + key.slice(7)] = value[key];
        });
        value.capturedAt = value.attribution_captured_at;
      }
      return value;
    } catch (_error) {
      return null;
    }
  }

  function writeStored(value) {
    if (!storageAllowed()) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (_error) {
      // Attribution is helpful reporting context. It must never block booking.
    }
  }

  function metaCookie(name) {
    try {
      var entry = document.cookie.split(';').map(function (part) { return part.trim(); })
        .find(function (part) { return part.indexOf(name + '=') === 0; });
      var value = entry ? decodeURIComponent(entry.slice(name.length + 1)) : '';
      var match = /^fb\.\d+\.(\d{13})\.([A-Za-z0-9_-]+)(?:\.[A-Za-z0-9_-]+)*$/.exec(value);
      if (!match || value.length > 512 || Number(match[1]) > Date.now()) return '';
      if (name === '_fbc' && (Number(match[1]) > Date.now() || Date.now() - Number(match[1]) > MAX_AGE_MS)) return '';
      return value;
    } catch (_error) { return ''; }
  }

  function pinterestClick(value) {
    var raw = String(value || '').trim();
    return /^[A-Za-z0-9_=-]{1,512}$/.test(raw) ? raw : '';
  }

  function pinterestCookie() {
    try {
      var entry = document.cookie.split(';').map(function (part) { return part.trim(); })
        .find(function (part) { return part.indexOf('_epik=') === 0; });
      return entry ? pinterestClick(decodeURIComponent(entry.slice(6))) : '';
    } catch (_error) { return ''; }
  }

  function touch(prefix, search, current, cookieOnly, capturedAtMs) {
    delete current[prefix + 'raw_medium'];
    delete current[prefix + 'raw_campaign'];
    var previousClick = current[prefix + 'fbclid'];
    var previousFbc = current[prefix + 'fbc'];
    UTM_KEYS.forEach(function (key) {
      var value = clean(search.get(key));
      delete current[prefix + key.slice(4)];
      if (value) current[prefix + key.slice(4)] = value;
    });
    if (GOOGLE_CLICK_MEMORY_ENABLED && googleAggregate(search) &&
        (!current[prefix + 'campaign'] || current[prefix + 'campaign'] === 'sag_organic')) {
      if (current[prefix + 'campaign']) current[prefix + 'raw_campaign'] = current[prefix + 'campaign'];
      current[prefix + 'campaign'] = search.get('gad_campaignid');
    }
    CLICK_KEYS.forEach(function (key) {
      var value = captureValue(key, search.get(key));
      delete current[prefix + key];
      if (value) current[prefix + key] = value;
    });
    // URL context wins over an unrelated persistent cookie. An initial untagged
    // visit may use _epik; a new tagged touch without epik clears it. We do not
    // infer a fresh Pinterest paid click from a cookie alone or create cookies.
    if (!current[prefix + 'epik'] && cookieOnly && !search.has('epik')) {
      var epik = pinterestCookie();
      if (epik) current[prefix + 'epik'] = epik;
    }
    current[prefix + 'source_explicit'] = Boolean(clean(search.get('utm_source')));
    delete current[prefix + 'fbc'];
    delete current[prefix + 'fbp'];
    var fbclid = current[prefix + 'fbclid'];
    var fbc = metaCookie('_fbc');
    var fbp = metaCookie('_fbp');
    // A cookie can outlive the click that created it. Attach it to a tagged touch
    // only when its click ID matches. Never carry it into another campaign.
    if (fbclid && /^[A-Za-z0-9_-]+$/.test(fbclid)) {
      current[prefix + 'fbc'] = fbc && fbc.split('.')[3] === fbclid ? fbc :
        previousClick === fbclid && previousFbc ? previousFbc : 'fb.1.' + capturedAtMs + '.' + fbclid;
    } else if (cookieOnly && fbc) {
      current[prefix + 'fbc'] = fbc;
    }
    if (fbp) current[prefix + 'fbp'] = fbp;
    inferClickTouch(prefix, current);
  }

  function inferClickTouch(prefix, current) {
    var aggregate = false;
    try { aggregate = GOOGLE_CLICK_MEMORY_ENABLED && googleAggregate(new URL(current[prefix + 'landing_url']).searchParams); }
    catch (_error) { /* Old storage may have no landing URL. */ }
    var inferred = ['gclid', 'gbraid', 'wbraid'].some(function (key) { return clean(current[prefix + key]); }) ? ['google', 'cpc'] :
      aggregate ? ['google', 'cpc'] :
      clean(current[prefix + 'fbclid']) ? ['facebook', 'paid'] :
      clean(current[prefix + 'msclkid']) ? ['bing', 'cpc'] :
      GOOGLE_CLICK_MEMORY_ENABLED && clean(current[prefix + 'epik']) && /[?&]epik=/.test(current[prefix + 'landing_url'] || '') ? ['pinterest', 'paid_social'] : null;
    if (GOOGLE_CLICK_MEMORY_ENABLED && inferred && inferred[0] === 'google' && current[prefix + 'medium'] === 'product_sync') {
      current[prefix + 'raw_medium'] = 'product_sync';
      current[prefix + 'source'] = 'google';
      current[prefix + 'medium'] = 'cpc';
    }
    var source = current[prefix + 'source'];
    var explicit = current[prefix + 'source_explicit'];
    try {
      explicit = explicit || Boolean(new URL(current[prefix + 'landing_url']).searchParams.get('utm_source'));
    } catch (_error) { /* Old storage may have no landing URL. */ }
    // Explicit UTMs win, even an explicitly supplied unknown/direct source.
    if (inferred && !explicit && (!source || source === 'unknown/direct')) {
      current[prefix + 'source'] = inferred[0];
      current[prefix + 'medium'] = current[prefix + 'medium'] || inferred[1];
    }
  }

  function googleAggregate(search) {
    return /^\d{1,20}$/.test(search.get('gad_source') || '') && /^\d{1,20}$/.test(search.get('gad_campaignid') || '');
  }

  function externalReferrer() { return externalReferrerValue(document.referrer); }

  function externalReferrerValue(raw) {
    var value = safeUrl(raw, false);
    try {
      if (GOOGLE_CLICK_MEMORY_ENABLED && /(^|\.)agdesignerjeweller\.com$/i.test(new URL(value).hostname)) return '';
    } catch (_error) { return ''; }
    return value;
  }

  function ensureFbp() {
    if (!advertisingAllowed()) return '';
    var existing = metaCookie('_fbp');
    if (existing) return existing;
    if (!/(^|\.)agdesignerjeweller\.com$/i.test(window.location.hostname)) return '';
    try {
      var random = new Uint32Array(1);
      window.crypto.getRandomValues(random);
      var value = 'fb.1.' + Date.now() + '.' + random[0];
      document.cookie = '_fbp=' + value + '; Domain=.agdesignerjeweller.com; Path=/; Max-Age=7776000; SameSite=Lax; Secure';
      return metaCookie('_fbp');
    } catch (_error) { return ''; }
  }

  function rememberPlatforms(current, search, newTouch, now) {
    // Separate expiry clocks preserve a recent click when the original touch
    // expires. These values never change the reporting original/latest touch.
    var memory = {};
    try { memory = JSON.parse(window.localStorage.getItem(PLATFORM_KEY) || '{}') || {}; }
    catch (_error) { /* Corrupt/blocked storage starts without platform memory. */ }
    if (!memory || typeof memory !== 'object' || Array.isArray(memory)) memory = {};
    ['meta', 'google'].forEach(function (key) {
      var entry = memory[key];
      if (!entry || !Number.isFinite(entry.at) || entry.at > now || now - entry.at > MAX_AGE_MS) delete memory[key];
    });
    function rememberMeta(fbc) {
      var match = /^fb\.\d+\.(\d{13})\.[A-Za-z0-9_-]+(?:\.[A-Za-z0-9_-]+)*$/.exec(fbc || '');
      var at = match && Number(match[1]);
      if (match && fbc.length <= 512 && at <= now && now - at <= MAX_AGE_MS &&
          (!memory.meta || at >= memory.meta.at)) memory.meta = { at: at, fbc: fbc };
    }
    var priorMeta = memory.meta;
    delete memory.meta;
    if (priorMeta) rememberMeta(priorMeta.fbc);
    rememberMeta(metaCookie('_fbc'));
    rememberMeta(current.latest_fbc);
    var googleClick = ['gclid', 'gbraid', 'wbraid'].some(function (key) { return clean(search.get(key)); });
    var gad = googleAggregate(search);
    if (GOOGLE_CLICK_MEMORY_ENABLED && newTouch && (googleClick || gad)) {
      var google = { at: now };
      ['gclid', 'gbraid', 'wbraid'].forEach(function (key) { var value = clean(search.get(key)); if (value) google[key] = value; });
      if (gad) {
        var attributes = { gad_source: search.get('gad_source'), gad_campaignid: search.get('gad_campaignid'),
          session_start_time_usec: String(now * 1000), landing_page_user_agent: clean(window.navigator.userAgent, 1024) };
        // Omit optional full URLs rather than uploading queries that may hold PII.
        try {
          google.session_attributes = window.btoa(unescape(encodeURIComponent(JSON.stringify(attributes))))
            .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        } catch (_error) { /* Optional metadata cannot block a booking. */ }
      }
      memory.google = google;
    } else if (GOOGLE_CLICK_MEMORY_ENABLED) {
      // _gcl_aw can be shared by the builder subdomain even though localStorage
      // is origin-scoped. Never relabel the latest reporting touch from a cookie.
      try {
        var entry = document.cookie.split(';').map(function (part) { return part.trim(); })
          .find(function (part) { return part.indexOf('_gcl_aw=') === 0; });
        var match = entry && /^GCL\.(\d{10})\.([A-Za-z0-9_-]{1,512})$/.exec(decodeURIComponent(entry.slice(8)));
        var at = match && Number(match[1]) * 1000;
        // A later linker timestamp for the same click must not discard its URL metadata.
        if (match && at <= now && now - at <= MAX_AGE_MS &&
            (!memory.google || (match[2] !== memory.google.gclid && at > memory.google.at))) {
          memory.google = { at: at, gclid: match[2] };
        }
      } catch (_error) { /* Invalid cookie. */ }
    }
    delete current.meta_fbc;
    ['gclid', 'gbraid', 'wbraid', 'session_attributes'].forEach(function (key) {
      delete current['google_' + key];
      if (GOOGLE_CLICK_MEMORY_ENABLED && memory.google && memory.google[key]) current['google_' + key] = memory.google[key];
    });
    if (memory.meta) current.meta_fbc = memory.meta.fbc;
    try { window.localStorage.setItem(PLATFORM_KEY, JSON.stringify(memory)); } catch (_error) { /* Best effort. */ }
  }

  function installBookingListener() {
    if (!GOOGLE_CLICK_MEMORY_ENABLED || window.location.pathname !== '/pages/booking' || window.__agConsultListener) return;
    window.__agConsultListener = true;
    var types = {
      'Engagement ring consultation': 'consult', 'Wedding ring consultation': 'consult',
      'Bespoke jewellery consultation': 'consult', 'Engagement ring consultation - A.G': 'consult',
      'Bespoke jewellery consultation - A.G': 'consult', 'Wedding ring consultation - A.G': 'consult',
      'Virtual Call - Engagement ring consultation': 'consult', 'Virtual Call - Wedding ring consultation': 'consult',
      'Virtual Call - Bespoke jewellery consultation': 'consult', 'Jewellery Redesign': 'consult',
      'A.G Gift Suite': 'gift_suite', 'Virtual - A.G Gift Suite': 'gift_suite'
    };
    function listen(messageEvent) {
      window.addEventListener('message', function (event) {
        if (event.origin !== 'https://conversion-tracking-sandbox.acuityinnovation.com' &&
            event.origin !== 'https://sandbox.acuityinnovation.com') return;
        try {
          var data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
          var appointmentId = data && (typeof data.ID === 'string' ? data.ID : Number.isSafeInteger(data.ID) ? String(data.ID) : '');
          if (!data || data.event !== messageEvent ||
              (messageEvent === 'AcuityEvent' ? data.Type !== 'appointment' : data.Type !== undefined && data.Type !== 'appointment') ||
              typeof data.AppointmentType !== 'string' || !data.AppointmentType.trim() ||
              data.AppointmentType.length > 256 || /[\r\n]/.test(data.AppointmentType) ||
              !/^[1-9]\d{0,19}$/.test(appointmentId) || !storageAllowed()) return;
          var leadType = Object.prototype.hasOwnProperty.call(types, data.AppointmentType) ? types[data.AppointmentType] : 'workshop';
          // The new Acuity branch is deliberately non-consult. Keep legacy Gift
          // Suite/workshop messages safe during either release order as well.
          if (messageEvent === 'AgAcuityBooking' && leadType === 'consult') return;
          var key = 'ag_consult_booked_v1:' + appointmentId;
          if (window.sessionStorage.getItem(key)) return;
          window.sessionStorage.setItem(key, '1');
          if (window.sessionStorage.getItem(key) !== '1') return;
          // Parent gtag keeps the visitor's session and consent-mode state. No
          // Email, FullName, payload spread, client/session ID or iframe delay.
          window.dataLayer = window.dataLayer || [];
          if (typeof window.gtag !== 'function') window.gtag = function () { window.dataLayer.push(arguments); };
          var params = { send_to: 'G-6643FSMQ1R', lead_type: leadType, appointment_id: appointmentId };
          if (leadType !== 'consult') params.appointment_type = data.AppointmentType;
          var eventName = leadType === 'consult' ? 'consult_booked' : leadType === 'gift_suite' ? 'gift_suite_booked' : 'workshop_booked';
          window.gtag('event', eventName, params);
        } catch (_error) { /* Includes sizing messages and unavailable storage. */ }
      });
    }
    listen('AcuityEvent');
    listen('AgAcuityBooking');
  }

  function capture() {
    if (!storageAllowed()) return {};
    var fbp = ensureFbp();
    var capturedAtMs = Date.now();
    var now = new Date(capturedAtMs).toISOString();
    var search = new URLSearchParams(window.location.search);
    var attributable = (GOOGLE_CLICK_MEMORY_ENABLED && googleAggregate(search)) ||
      UTM_KEYS.concat(CLICK_KEYS).some(function (key) { return key === 'epik' ? search.has(key) : clean(search.get(key)); });
    var existing = readStored();
    var current = existing || {
      capturedAt: now,
      original_landing_url: safeUrl(window.location.href, true),
      original_referrer: externalReferrer()
    };

    var newTouch = !existing || (attributable && capturedUrl !== window.location.href);
    if (!existing) touch('original_', search, current, !attributable, capturedAtMs);
    if (newTouch) {
      // Set this before inference: a prior landing URL must not govern this touch.
      current.latest_landing_url = safeUrl(window.location.href, true);
      touch('latest_', search, current, !attributable, capturedAtMs);
      current.latest_source = current.latest_source || 'unknown/direct';
      current.latest_landing_url = safeUrl(window.location.href, true);
      current.latest_referrer = externalReferrer();
      current.attribution_captured_at = now;
    }

    inferClickTouch('original_', current);
    inferClickTouch('latest_', current);
    current.original_source = current.original_source || 'unknown/direct';
    current.latest_source = current.latest_source || 'unknown/direct';
    current.latest_landing_url = current.latest_landing_url || safeUrl(window.location.href, true);
    current.latest_referrer = current.latest_referrer || externalReferrer();
    current.attribution_captured_at = current.attribution_captured_at || current.capturedAt;
    var active = activeTouch(current, capturedAtMs, newTouch, !existing);
    if (active) {
      fillMetaIdentity('latest_', current, Date.parse(current.attribution_captured_at));
      if (active.original === true) fillMetaIdentity('original_', current, Date.parse(current.capturedAt));
    }
    // fbp identifies the browser, independently of which channel touched last.
    if (fbp) {
      current.latest_fbp = fbp;
      if (!current.original_fbp) current.original_fbp = fbp;
    } else {
      delete current.original_fbp;
      delete current.latest_fbp;
    }
    if (current.latest_referrer && !externalReferrerValue(current.latest_referrer)) current.latest_referrer = '';
    // Aggregate Google parameters enrich platform memory without replacing the reporting touch.
    rememberPlatforms(current, search, newTouch || capturedUrl !== window.location.href, capturedAtMs);
    capturedUrl = window.location.href;
    writeStored(current);
    return current;
  }

  function decorateAcuityUrl(rawUrl, fieldIds) {
    var url = new URL(rawUrl, window.location.origin);
    var values = capture();
    Object.keys(fieldIds || {}).forEach(function (canonicalKey) {
      var fieldId = Number(fieldIds[canonicalKey]);
      var captureKey = canonicalKey.replace(/^latest_utm_/, 'latest_');
      var value = clean(values[captureKey], canonicalKey === 'google_session_attributes' ? 7000 : 2048);
      if (Number.isSafeInteger(fieldId) && fieldId > 0) {
        url.searchParams.delete('field:' + fieldId);
        if (value) url.searchParams.set('field:' + fieldId, value);
      }
    });
    return url.toString();
  }

  window.AGAttribution = Object.freeze({
    capture: capture,
    decorateAcuityUrl: decorateAcuityUrl,
    storageAllowed: storageAllowed,
    advertisingAllowed: advertisingAllowed,
    metaCookie: metaCookie,
    storageKey: STORAGE_KEY
  });

  function privacyChanged() {
    if (!storageAllowed()) {
      // Withdrawal removes our own previously captured marketing context.
      try { window.localStorage.removeItem(STORAGE_KEY); window.localStorage.removeItem(PLATFORM_KEY); } catch (_error) { /* Storage may be blocked. */ }
      try { window.sessionStorage.removeItem(ACTIVE_TOUCH_KEY); } catch (_error) { /* Storage may be blocked. */ }
      capturedUrl = '';
    }
    capture();
    document.dispatchEvent(new CustomEvent('ag:attribution-updated'));
  }

  document.addEventListener('visitorConsentCollected', privacyChanged);
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) privacyChanged();
    });
  }
  installBookingListener();
  capture();
  function retryAfterLoad() {
    window.setTimeout(function () {
      capture();
      document.dispatchEvent(new CustomEvent('ag:attribution-updated'));
    }, 1000);
  }
  if (document.readyState === 'complete') retryAfterLoad();
  else window.addEventListener('load', retryAfterLoad, { once: true });
}(window, document));
